
import img0 from './Images/Add_Data_Access_Role.png';
  
const content = `# Data Access Roles
The OnData product allows you to consistently and conveniently manage the access to your sensitive data, no matter where the data is stored. By default, the sensitive data 
in files and databases is strongly encrypted and no one has access to it. For authenticated and authorized users, the encrypted data can be dynamically decrypted during 
runtime into its original form. The user authorization to access the sensitive data is managed through data access roles. When you integrate the OnData product with 
your Identity and Access Management (IAM) system, the data access roles can be assigned to users or user groups in your IAM system. In that case, you can centrally manage 
who can access what kind of sensitive data from your IAM system, instead of managing data access in every data repository. For details on how to assign data access roles 
to users or user groups in your IAM system, please refer to the example of [**Assigning Roles In Entra ID**](reference_doc#ondata_portal/sso_integration/entraid_role_assignment) or 
[**Assigning Roles In Okta**](reference_doc#ondata_portal/sso_integration/okta_role_assignment).
  
A data access role defines what types of data a user has access to. It may include "Read" and "Write" access. When a user has the "Read" access to a data 
classification, the data of that classification will be automatically decrypted for that user, when that user utilizes the OnData toolset to access the data. 
When a user has the "Write" access to a data classification, the data of that classification can be modified by that user. The modified data will be 
automatically encrypted using the OnData toolset before it is stored.  
  
Please follow the steps below to create a data access role:  
a. Login to the OnData and go to Settings  
b. Select "Data Access Policy", and on the "Data Access Roles" tab, click on the "Add Data Access Role" button  
c. Enter the role name, role value, and description for the new data access role. The role value will be used in your IAM system and cannot contain whitespaces  
d. Select the "Read" and "Write" access to the appropriate list of data classifications for this new data access role. Please note that a user must have 
the "Read" access if the "Write" access is selected for a data classification  
  
![Add Data Access Role](${ img0 })  
  
e. Click on the "Save" button to create the new data access role  
  

  `
  
export default content;
